import jsPDF from "jspdf";
import { GTMsendEvent } from "./trackingGA4";
import { translateServices } from ".";
import i18next from "i18next";
import usePdfStore from "../store/PdfStore";
import { FORMAT_DATE_TIME } from '../utils/constants';
import dayjs from 'dayjs';

export const fixSpaces = (str: string | number) => {

    if (!str) {
        return ''
    }

    if (typeof str === 'number') {
        str = str.toString()
    }

    return str.replaceAll(
        ' ',
        '\xa0\xa0'
    );
};

export const generatePdf = (
    onDone: (filename: string, pdfBlob: Blob) => void,
    typePdfTemplate = "#pdfContent",
    filename = `${i18next.t('quotation')}.pdf`,
    dataGtm: any = null,
    downloadFile: boolean = true,
) => {
    const { quickoGtmSendData } = usePdfStore.getState();
    var doc = new jsPDF({ compress: true });
    var elementHTML: HTMLElement | null = document.querySelector(typePdfTemplate);
    const sessionKey = 'generatingpdf';
    if (sessionStorage.getItem(sessionKey)) {
        return;
    }
    sessionStorage.setItem(sessionKey, '1');
    doc.html(elementHTML!, {
        callback: function (doc) {
            sessionStorage.removeItem(sessionKey);
            downloadFile && doc.save(filename);
            const pdfBlob =  new Blob([ doc.output('blob') ], { type : 'application/pdf'});
            onDone(filename, pdfBlob);
        },
        margin: [10, 10, 10, 10],
        autoPaging: 'text',
        x: 0,
        y: 0,
        width: 190, //target width in the PDF document
        windowWidth: 675, //window width in CSS pixels
    });

    const source = dataGtm?.source;
    if (source === "quicko_pdf" && dataGtm) {

        GTMsendEvent({
            event: 'CTA_download_preventivo_Quicko',
            evtCat: 'preventivo_veicolo',
            evtAct: "download",
            evtLab: `${filename}`,
            noleggiatore: dataGtm.row?.noleggiatore,
            dealer: dataGtm.dettagli_veicolo?.dealer,
            date: dayjs().format(FORMAT_DATE_TIME),
            ...quickoGtmSendData,
        });
    } else {
        GTMsendEvent({
            event: "CTA_download_file",
            evtCat: 'preventivo_veicolo',
            evtAct: "download",
            evtLab: `${filename}`
        });
    }
};

export function mapServices(services: string, dettListaOfferteServ: any) {
    Object.entries(dettListaOfferteServ).forEach(([key, value], index) => {
        let valService;

        if (typeof value === 'boolean') {
            valService = value ? 'Si' : 'No';
        } else {
            valService = String(value);
        }

        if (valService) {

            if (!isNaN(parseInt(valService)) || valService.includes('€')) {
                if (valService.split(" ").length < 2) {
                    value = parseInt(valService).toLocaleString('it') + ' €';
                } else {
                    if (valService.includes('€')) {
                        value = valService.replace('€', '') + ' €';
                    }
                }
            }
            services += (key === 'additional_note' ? valService : (translateServices(key) + ': ' + valService))?.trim();
            if (index < Object.entries(dettListaOfferteServ).length - 1) {
                services += '\n';
            }
        }
    });

    return services;
}
